import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'product-or-family-modal',
    templateUrl: './product-or-family-modal.component.html',
    styleUrls: ['./product-or-family-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProductOrFamilyModal implements OnInit {

    newPromoLine : boolean = false;
    choice : string;
    
    constructor(
        public dialogRef: MatDialogRef<ProductOrFamilyModal>,  @Inject(MAT_DIALOG_DATA) public data: any,
        ) {
        this.newPromoLine  = data.newPromoLine;
    }


    ngOnInit() {}


    getProductOrProductFamilyMessage(line : number) : string {
        let message : string = "";
        if (! this.newPromoLine) {
            if (line == 1){
                message = "Il s'agit maintenant de définir la condition d'application de la promotion"
            } else {
                message = "Cette condition d'application de la promotion peut être basée soit sur l'achat d'un produit soit sur l'achat d'une famille de produits";
            }
        } else {
            if (line == 1){
                message = "Il s'agit maintenant de définir les produits concernés par la remise ou la gratuité"
            } else {
                message = "Il peut s'agir d'un produit ou d'une famille de produits";
            }
        }
    
        return message;
    }


    public validate(choice : string) {
        this.closeModal(choice);
    }

    close(){
        this.closeModal(null);
    }
      
    closeModal(choice : string){
        this.dialogRef.close(choice);
    }
}
